import Glide from '@glidejs/glide';

export default () => {

    if (document.querySelector('.hero') !== null) {
        var glideHero = new Glide('.hero', {
            type: 'slider',
            perView: 1
        })

        glideHero.mount();
    }

    //fade in on scroll

    /* Every time the window is scrolled ... */
    $(window).scroll( function(){

        /* Check the location of each desired element */
        $('.home section').each( function(i){

            var bottom_of_object = $(this).position().top ;
            var bottom_of_window = $(window).scrollTop() + $(window).height();

            /* If the object is completely visible in the window, fade it it */
            if( bottom_of_window > bottom_of_object ){

                $(this).animate({'opacity':'1'},1000);

            }

        });

    });
};
